/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/social-export-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { GetUploadQueryResponse, GetUploadPathParams } from "../models/GetUpload";

export function getGetUploadUrl(id: GetUploadPathParams["id"]) {
  const res = { method: 'GET', url: `/upload/${id}` as const }
  return res
}

/**
 * @summary Get upload by ID
 * {@link /upload/:id}
 */
export async function getUpload(id: GetUploadPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetUploadQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetUploadUrl(id).url.toString(), ... requestConfig })
  return res.data
}